// extracted by mini-css-extract-plugin
module.exports = {"rotate":"svg-module--rotate--1Ibo9","rotation":"svg-module--rotation--4op4X","rotateConatiner":"svg-module--rotateConatiner--3gXaH"};